import { AppState } from "../../types";
import { SET_LOADING_STATE, RESET_LOADING_STATE, CHNAGE_LANGUAGE } from "../constants";

const initialState: AppState = {
    loading: false,
    locale: "en"
};

// eslint-disable-next-line
export default (state = initialState, action: any): any => {
    switch (action.type) {
        case SET_LOADING_STATE:
            return {
                ...state,
                loading: true
            };
        case RESET_LOADING_STATE:
            return {
                ...state,
                loading : false
            }
        case CHNAGE_LANGUAGE:
            return {
                ...state, 
                locale : action.payload
            }
        default: return state;
    }
};